module.exports = __webpack_public_path__ + "static/media/girl.5261bd49.png";